import Education from "../Components/Basiceditor/Education/Education";
import Profile from "../Components/Basiceditor/Profile/Profile";
import Skill from "../Components/Basiceditor/Skill/Skill";
import Summary from "../Components/Basiceditor/Summary/Summary";
import Workexperience from "../Components/Basiceditor/Workexperience/Workexperience";
import Achievements from "../Components/Basiceditor/Achievements/Achievements";
import Languages from "../Components/Basiceditor/Languages/Languages";
import Interests from "../Components/Basiceditor/Interests/Interests";
import CustomDate from "../Components/Basiceditor/CustomSection/CustomSection";
import CustomText from "../Components/Basiceditor/customTextSection/customText";
import CommonDate from "../Components/Basiceditor/CommonDate/CommonDate";
import CommonText from "../Components/Basiceditor/CommonText/CommonText";

export const componentGeneratorTwo = (
  id,
  type,
  resumeFields,
  resumeHandler,
  resumeUpdate,
  addResumeField,
  resumeAllFields,
  setResumeFields,
  resumeTitleHandler,
  handleEditorChange,
  resumeTitleRemove,
  dateHandler,
  deletePopupShow,
  languageHandler,
  contentAdder,
  handleItemDelete
) => {
  const componentType = type;
  let provided = id;
  let section = id;
  if (id.includes("customDate")) {
    section = "customDate";
  } else if (id.includes("customText")) {
    section = "customText";
  } else {
    section = id;
  }
  switch (section) {
    case "education":
      return (
        componentType === "basiceditor" && (
          <Education
            provided={provided}
            sectionId="education"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );

    case "languages":
      return (
        componentType === "basiceditor" && (
          <Languages
            provided={provided}
            sectionId="languages"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "achievements":
      return (
        componentType === "basiceditor" && (
          <Achievements
            provided={provided}
            sectionId="achievements"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "interests":
      return (
        componentType === "basiceditor" && (
          <Interests
            provided={provided}
            sectionId="interests"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "customText":
      return (
        componentType === "basiceditor" && (
          <CustomText
            provided={provided}
            sectionId={id}
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            deletePopupShow={deletePopupShow}
          />
        )
      );
    case "customDate":
      return (
        componentType === "basiceditor" && (
          <CustomDate
            provided={provided}
            sectionId={id}
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
          />
        )
      );
    case "projects":
      return (
        componentType === "basiceditor" && (
          <CommonDate
            provided={provided}
            sectionId="projects"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "volunteering":
      return (
        componentType === "basiceditor" && (
          <CommonDate
            provided={provided}
            sectionId="volunteering"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "onlinePresence":
      return (
        componentType === "basiceditor" && (
          <CommonText
            provided={provided}
            sectionId="onlinePresence"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
            languageHandler={languageHandler}
          />
        )
      );
    case "certifications":
      return (
        componentType === "basiceditor" && (
          <CommonDate
            provided={provided}
            sectionId="certifications"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "references":
      return (
        componentType === "basiceditor" && (
          <CommonText
            provided={provided}
            sectionId="references"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
            languageHandler={languageHandler}
          />
        )
      );
    case "publications":
      return (
        componentType === "basiceditor" && (
          <CommonDate
            provided={provided}
            sectionId="publications"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "books":
      return (
        componentType === "basiceditor" && (
          <CommonText
            provided={provided}
            sectionId="books"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
            languageHandler={languageHandler}
          />
        )
      );
    case "additionalExperience":
      return (
        componentType === "basiceditor" && (
          <CommonDate
            provided={provided}
            sectionId="additionalExperience"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );
    case "additionalSkills":
      return (
        componentType === "basiceditor" && (
          <CommonText
            provided={provided}
            sectionId="additionalSkills"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
            languageHandler={languageHandler}
          />
        )
      );
    case "courses":
      return (
        componentType === "basiceditor" && (
          <CommonText
            provided={provided}
            sectionId="courses"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
            languageHandler={languageHandler}
          />
        )
      );
    case "industryExpertise":
      return (
        componentType === "basiceditor" && (
          <CommonText
            provided={provided}
            sectionId="industryExpertise"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
            languageHandler={languageHandler}
          />
        )
      );
    case "techStack":
      return (
        componentType === "basiceditor" && (
          <CommonDate
            provided={provided}
            sectionId="techStack"
            resumeFields={resumeFields}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeAllFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            dateHandler={dateHandler}
            deletePopupShow={deletePopupShow}
            handleItemDelete={handleItemDelete}
          />
        )
      );

    default:
      break;
  }
};
